import dateFormat from 'dateformat';

export function getReadableDate(dateStr: string) {
  return dateFormat(dateStr, 'mmmm d, yyyy');
}

export function getMonthAndYearFromDate(dateStr: string) {
  const formatted = dateFormat(dateStr, 'yyyy mm').split(' ');
  return {
    year: formatted[0],
    month: formatted[1],
  };
}
